import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { api } from "../../../api/apiService";
import { Spinner } from "react-bootstrap";
import { InitialAvatar } from "../../../config/utils";
import DashboardOverview from '../../../components/charts/DashboardOverview';
import OnTimeCheck from '../../../components/charts/OnTimeCheck';
import AttendanceReport from '../../../components/charts/AttendanceReport';

const RealtimeAttendance = () => {
    const [attendanceList, setAttendanceList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchRealtimeAttendance();
    }, []);

    const fetchRealtimeAttendance = async () => {
        try {
            setIsLoading(true);
            const response = await api.get("/realtime-attendance");
            setAttendanceList(response.data);
        } catch (error) {
            console.error("Error fetching attendance: ", error);
            toast.error("Failed to fetch attendance");
        } finally {
            setIsLoading(false);
        }
    };

    // const getInitials = (name) => {
    //     return name ? name.charAt(0).toUpperCase() : '?';
    // };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Today's Summary</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/home">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">Today's Summary</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        {isLoading ? (
                            <div className="text-center mt-3">
                                <Spinner animation="border" variant="primary" />
                                <span className="ms-2">Loading...</span>
                            </div>
                        ) : (
                            <>
                                <div className="my-3">
                                    <div className="row g-3 align-items-stretch">
                                        <div className='col-md-8 d-flex flex-column'>
                                            <div className='row g-2 align-items-stretch flex-grow-1'>
                                                <div className="col-12 col-sm-6 col-md-3 d-flex">
                                                    <div className="card shadow-none p-3 w-100 h-100 mb-0">
                                                        <div className="text-muted small mb-1">
                                                            <i className="bi bi-clock-history clock-icon me-2"></i>
                                                            Shift: ({attendanceList?.today_summary?.currentShift || 'N/A'})
                                                        </div>
                                                        <div className="d-flex gap-1 text-truncate" style={{ marginTop: '12px' }}>
                                                            <div className="fw-semibold fs-6"  style={{ marginRight: '4px' }}>
                                                                {attendanceList?.today_summary?.currentShiftStartTime?.split(" ")[0]}
                                                                <span className="text-uppercase  ms-0" style={{ fontSize: '11px' }}>
                                                                {attendanceList?.today_summary?.currentShiftStartTime?.split(" ")[1]}
                                                                </span>
                                                            </div>
                                                            <div className="fw-semibold fs-6">
                                                                {attendanceList?.today_summary?.currentShiftEndTime?.split(" ")[0]}
                                                                <span className="text-uppercase  ms-0"  style={{ fontSize: '11px' }}>
                                                                {attendanceList?.today_summary?.currentShiftEndTime?.split(" ")[1]}
                                                                </span>
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-3 d-flex">
                                                    <div className="card shadow-none p-3 w-100 h-100 mb-0">
                                                        <div className="text-muted small mb-1">Present</div>
                                                        <div className="d-flex gap-4">
                                                            <div className="fw-semibold fs-5 text-truncate" style={{ marginTop: '12px' }}>
                                                                <i className="person-icon person-check me-3 bi bi-person-check"></i>
                                                                {attendanceList?.today_summary?.present_count || 0}
                                                                <span className="font-12 ms-1">Employees</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-3 d-flex">
                                                    <div className="card shadow-none p-3 w-100 h-100 mb-0">
                                                        <div className="text-muted small mb-1">Absent</div>
                                                        <div className="d-flex gap-4">
                                                            <div className="fw-semibold fs-5 text-truncate" style={{ marginTop: '12px' }}>
                                                                <i className="person-icon person-x me-3 bi bi-person-x"></i>
                                                                {attendanceList?.today_summary?.absent_count || 0}
                                                                <span className="font-12 ms-1">Employees</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-3 d-flex">
                                                    <div className="card shadow-none p-3 w-100 h-100 mb-0">
                                                        <div className="text-muted small mb-1">Total</div>
                                                        <div className="d-flex gap-4">
                                                            <div className="fw-semibold fs-5 text-truncate" style={{ marginTop: '12px' }}>
                                                                <i className="person-icon person-down me-3 bi bi-person-down"></i>
                                                                {attendanceList?.today_summary?.total_in_shift || 0}/{attendanceList?.today_summary?.total_employees || 0}
                                                                <span className="font-12 ms-1">Employees</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 mt-3">
                                                    <div className='card shadow-none mb-0'>
                                                        <div className='card-body'>
                                                            <OnTimeCheck />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-4 d-flex flex-column'>
                                            <div className='card mb-0 shadow-none flex-grow-1'>
                                                <div className='card-body'>
                                                    <DashboardOverview />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <h5 className="card-title">Latest Entry/Exit</h5> */}
                                {/* {attendanceList?.attendances?.length > 0 && attendanceList.attendances.slice(0, 1).map((attendance, index) => (
                                    <div className="card mb-2 mt-2 border" key={index}>
                                        <div className="card-body p-4">
                                            <div className="row g-3 align-items-center">
                                                <div className="col-auto">
                                                    {attendance.profile_picture ? (
                                                        <img
                                                            src={attendance.profile_picture}
                                                            alt={attendance.employee_name}
                                                            style={{
                                                                width: '60px',
                                                                height: '60px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                    ) : (
                                                        <div
                                                            style={{
                                                                width: '60px',
                                                                height: '60px',
                                                                backgroundColor: '#007bff',
                                                                borderRadius: '50%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: 'white',
                                                                fontSize: '24px',
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            {getInitials(attendance.employee_name)}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-3">
                                                    <h5 className="mb-1">Name</h5>
                                                    <p className="mb-0">
                                                        {attendance.employee_name} ({attendance.role})
                                                    </p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-3">
                                                    <h5 className="mb-1">Type</h5>
                                                    <p className="mb-0">{attendance.check_type === "Check In" ? "Check In" : "Check Out"}</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-3">
                                                    <h5 className="mb-1">Employee Id</h5>
                                                    <p className="mb-0">{index + 1}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))} */}
                                <div className='row g-3'>
                                    <div className='col-md-8 d-flex flex-column'>
                                        <div className='card shadow-none mb-0 flex-grow-1'>
                                            <div className='card-body'>
                                                <h4 className="text-muted text-sm font-semibold my-3">Activites Log</h4>
                                                <div className='table-responsive activities-log'>
                                                    <table className="table">
                                                        {/* <thead>
                                                                        <tr>
                                                                            <th>Employee</th>
                                                                            <th>Check Time</th>
                                                                            <th>Source</th>
                                                                            <th>Type</th>
                                                                        </tr>
                                                                    </thead> */}
                                                        <tbody>
                                                            {attendanceList?.attendances?.map((attendance, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <div className='d-flex align-items-center gap-2'>
                                                                            {attendance?.profile_picture ? (
                                                                                <img
                                                                                    src={attendance.profile_picture}
                                                                                    alt={attendance.employee_name}
                                                                                    style={{
                                                                                        width: '30px',
                                                                                        height: '30px',
                                                                                        borderRadius: '50%',
                                                                                        objectFit: 'cover'
                                                                                    }}
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.style.display = 'none';
                                                                                        e.target.nextSibling.style.display = 'flex';
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <InitialAvatar name={attendance.employee_name} />
                                                                            )}
                                                                            <span>{attendance.employee_name} ({attendance?.role})</span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {attendance?.check_time ? attendance?.check_time : '---'}
                                                                        {attendance?.check_type === "Check Out" && ` (${attendance?.shift_hours || "---"})`}
                                                                    </td>
                                                                    <td>{attendance?.source === 'Automatically' ? 'Auto' : attendance?.source === 'Biometric Device' ? 'Device' : (attendance?.source || '---')}</td>
                                                                    <td>
                                                                        <span className={attendance?.check_type === 'Check Out' ? 'badge bg-danger' : attendance?.check_type === 'Check In' ? 'badge bg-success' : ''}>
                                                                            {attendance?.check_type || '---'}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 d-flex flex-column'>
                                        <div className='card shadow-none mb-0 flex-grow-1'>
                                            <div className='card-body d-flex flex-column p-3'>
                                                <div className="absent-list d-flex flex-column flex-grow-1">
                                                    <h4 className="text-muted text-sm font-semibold">Today's Absent</h4>
                                                    <div className="activities-log flex-grow-1 overflow-auto">
                                                        {attendanceList?.absentEmployees?.map((attendance, index) => (
                                                            <div
                                                                className="absent-item d-flex align-items-center justify-content-between py-2"
                                                                key={index}
                                                                style={{
                                                                    borderBottom:
                                                                        index !== attendanceList.absentEmployees.length - 1
                                                                            ? '1px solid #f0f0f0'
                                                                            : 'none',
                                                                }}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    {attendance?.profile_picture ? (
                                                                        <img
                                                                            src={attendance.profile_picture}
                                                                            alt={attendance.name}
                                                                            className="rounded-circle me-3"
                                                                            style={{
                                                                                width: '48px',
                                                                                height: '48px',
                                                                                objectFit: 'cover',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <div className="me-3">
                                                                            <InitialAvatar name={attendance.name} />
                                                                        </div>
                                                                    )}
                                                                    <div>
                                                                        <div className="fw-bold text-dark">{attendance.name}</div>
                                                                        <div className="text-muted font-12">
                                                                            {attendance.designation || 'Employee'}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <i
                                                                    className="bi bi-box-arrow-in-right text-muted"
                                                                    style={{ fontSize: '18px', cursor: 'pointer' }}
                                                                ></i>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card shadow-none mb-0 mt-3'>
                                    <div className='card-body'>
                                        <AttendanceReport />
                                    </div>
                                </div>

                            </>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default RealtimeAttendance;